const PlusSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.49914 5.12891C8.49914 4.9963 8.44646 4.86912 8.35269 4.77535C8.25892 4.68158 8.13175 4.62891 7.99914 4.62891C7.86653 4.62891 7.73935 4.68158 7.64559 4.77535C7.55182 4.86912 7.49914 4.9963 7.49914 5.12891V7.49855H5.13672C5.00411 7.49855 4.87693 7.55123 4.78317 7.645C4.6894 7.73877 4.63672 7.86594 4.63672 7.99855C4.63672 8.13116 4.6894 8.25834 4.78317 8.3521C4.87693 8.44587 5.00411 8.49855 5.13672 8.49855H7.49914V10.9127C7.49914 11.0453 7.55182 11.1724 7.64559 11.2662C7.73935 11.36 7.86653 11.4127 7.99914 11.4127C8.13175 11.4127 8.25892 11.36 8.35269 11.2662C8.44646 11.1724 8.49914 11.0453 8.49914 10.9127V8.49855H10.8553C10.9879 8.49855 11.1151 8.44587 11.2088 8.3521C11.3026 8.25834 11.3553 8.13116 11.3553 7.99855C11.3553 7.86594 11.3026 7.73877 11.2088 7.645C11.1151 7.55123 10.9879 7.49855 10.8553 7.49855H8.49914V5.12891Z"
        fill="#D5D5D5"
      />
    </svg>
  );
};

export default PlusSvg;
